module.exports = __webpack_public_path__ + "img/prev-arrow-red.eb4c1f03.svg";